import { endpoints } from '../Constants';
import { authHeader, toQueryStringURL } from '../Helpers';
import handleResponse from './helpers';

const containerServices = {
	fetchContainerList,
	editContainer,
	saveContainer,
	removeContainer,
};

function fetchContainerList() {
	const requestOptions = {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
	};

	return fetch(endpoints.CONTAINER_LIST, requestOptions).then(handleResponse);
}
function editContainer(req = {}) {
	const { params = {} } = req;
	const url = toQueryStringURL(endpoints.CONTAINER_EDIT, params);
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON.stringify({
			...req?.data,
		}),
	};

	return fetch(url, requestOptions).then(handleResponse);
}
function removeContainer(req = {}) {
	const { params = {} } = req;
	const url = toQueryStringURL(
		endpoints.CONTAINER_REMOVE,
		params
	);
	const requestOptions = {
		method: 'DELETE',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON.stringify({
			...req?.data,
		}),
	};

	return fetch(url, requestOptions).then(handleResponse);
}
function saveContainer(req = {}) {
	const { params = {} } = req;
	const url = toQueryStringURL(endpoints.CONTAINER_ADD, params);
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON.stringify({
			...req?.data,
		}),
	};

	return fetch(url, requestOptions).then(handleResponse);
}

export default containerServices;
